import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompanyEventProto } from '../proto/generated/company_event'
import { CorporateAction } from '../proto/generated/corporate-action'

interface EventsState {
    companyEvents: { [symbol: string]: CompanyEventProto[] } | undefined;
    corporateActions: { [symbol: string]: CorporateAction[] } | undefined;
}

const initialState: EventsState = {
    companyEvents: undefined,
    corporateActions: undefined,
};

const companyEventsSlice = createSlice({
    name: "companyEvents",
    initialState,
    reducers: {
        storeCompanyEvents(state, action: PayloadAction<CompanyEventProto[]>) {
            const grouped: { [symbol: string]: CompanyEventProto[] } = {};
            action.payload.forEach((event) => {
                if (!grouped[event.companyCode]) {
                    grouped[event.companyCode] = [];
                }
                grouped[event.companyCode].push(event);
            });
            state.companyEvents = grouped;
        },
        storeCorporateActions(state, action: PayloadAction<CorporateAction[]>) {
            const grouped: { [symbol: string]: CorporateAction[] } = {};
            action.payload.forEach((actionItem) => {
                if (!grouped[actionItem.companyCode]) {
                    grouped[actionItem.companyCode] = [];
                }
                grouped[actionItem.companyCode].push(actionItem);
            });
            state.corporateActions = grouped;
        }
    }
});

export const { storeCompanyEvents, storeCorporateActions } = companyEventsSlice.actions;
export default companyEventsSlice.reducer;
